<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <a class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          href="#" data-bs-toggle="modal" data-bs-target="#createNewLevelModal" @click.prevent="handleModalClosed">
          Agregar Nivel
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </a>
      </div>
      <div class="d-flex align-items-center">
        <form class="search-box position-relative me-15" @submit.prevent="filterResults">
          <input type="text" v-model="searchQuery" class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Buscar" />
          <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>

      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                <span @click="toggleSortOrder" style="cursor: pointer;">
                  Nivel
                  <!-- Mostrar el ícono según el estado de ordenamiento -->
                  <i :class="isAscending ? 'flaticon-up-arrow' : 'flaticon-down-arrow'" style="margin-left: 5px;"></i>
                </span>
              </th>
              <th class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                Juego
              </th>
              <th class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                ACCIONES
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(level, index) in sortedLevels" :key="index">
              <th class="shadow-none lh-1 fw-medium text-black-emphasis title ps-0">
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-center ms-5 fs-md-15 fs-lg-16">
                    {{ level.name }}
                  </div>
                </div>
              </th>
              <th class="shadow-none lh-1 fw-medium text-black-emphasis title ps-0">
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-center ms-5 fs-md-15 fs-lg-16">
                    {{ level.game?.name }}
                  </div>
                </div>
              </th>
              <td class="action-link">
                <i class="ph ph-pencil action-link" style="font-size: 24px;" data-bs-toggle="modal"
                  data-bs-target="#createNewLevelModal" @click="openModal(level)" />
                <i class="ph ph-trash ms-2 action-link" style="font-size: 24px;" @click="deleteLevel(level.id)" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="pagination-area d-md-flex mb-25 justify-content-between align-items-center">
      <p class="ms-20 mb-0 text-paragraph">
        Mostrando <span class="fw-bold">{{ paginatedItems?.length }}</span> de
        <span class="fw-bold">{{ items?.length }}</span> Resultados
      </p>
      <nav class="mt-15 mt-md-0">
        <ul class="pagination mb-0">
          <li class="page-item">
            <a class="page-link" @click.prevent="goToPreviousPage" aria-label="Previous">
              <i class="flaticon-chevron-1"></i>
            </a>
          </li>
          <li class="page-item" v-for="page in totalPages" :key="page">
            <a class="page-link" @click.prevent="goToPage(page)">{{ page }}</a>
          </li>
          <li class="page-item">
            <a class="page-link" @click.prevent="goToNextPage" aria-label="Next">
              <i class="flaticon-chevron"></i>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
  <CreateNewLevelModal :axios="axios" :id="selectedItem?.id" :no-close-on-backdrop="true" :title="title"
    @modal-closed="handleModalClosed" />
</template>

<script>
import { computed } from "vue";
import CreateNewLevelModal from "./CreateNewLevelModal.vue";
import * as StateStore from "@/utils/store";
import Swal from "sweetalert2"; // Importa SweetAlert2

export default {
  name: "LevelList",
  props: {
    axios: {
      type: [Object, Function],
      required: true
    }
  },
  components: {
    CreateNewLevelModal,
  },
  data() {
    return {
      searchQuery: '',
      selectedItem: null,
      itemsPerPage: 10,
      currentPage: 1,
      items: [],
      isAscending: true,
      title: computed(() => this.selectedItem === null ? 'Crear Nuevo ' : 'Editar '),
    }
  },
  computed: {
    filteredAnswers() {
      if (this.items && this.items.length > 0) {
        return this.items.filter(item => {
          return (
            item.name?.toString().includes(this.searchQuery) ||
            item.game?.name?.toLowerCase().includes(this.searchQuery.toLowerCase())
          );
        });
      } else return []
    },
    sortedLevels() {
      // Crear una copia del array antes de ordenarlo
      return [...this.filteredAnswers].sort((a, b) => {
        const comparison = a.name - b.name;
        return this.isAscending ? comparison : -comparison;
      });
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      if (this.items && this.items.length) {
        return this.items.slice(start, end);
      } else return []
    },
    totalPages() {
      if (this.items && this.items.length) {
        return Math.ceil(this.items.length / this.itemsPerPage);
      } else return []
    }
  },
  methods: {
    filterResults() {
      // Método para manejar la búsqueda
    },
    handleModalClosed() {
      this.selectedItem = null;
    },
    openModal(item) {
      this.selectedItem = item;
      // console.log("selectedItem: ", this.selectedItem);
    },
    async deleteLevel(id) {
      // Usando SweetAlert2 para confirmar la eliminación
      const result = await Swal.fire({
        title: "¿Está seguro de eliminar este registro?",
        text: "No podrá revertir esta acción.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      });

      if (result.isConfirmed) {
        try {
          await StateStore.actions.actionsDeleteLevel({
            axios: this.axios,
            id,
          });
          await this.getAllLevels(); // Recarga los datos después de la eliminación.

          // Mostrar mensaje de éxito
          Swal.fire({
            title: "Eliminado",
            text: "El nivel ha sido eliminado correctamente.",
            icon: "success",
            confirmButtonText: "Aceptar",
          });
        } catch (error) {
          console.error("Error al eliminar el Nivel:", error);
          Swal.fire({
            title: "Error",
            text: "Hubo un problema al eliminar el nivel.",
            icon: "error",
            confirmButtonText: "Aceptar",
          });
        }
      }

    },
    toggleSortOrder() {
      this.isAscending = !this.isAscending;
    },
    goToPreviousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    goToPage(page) {
      this.currentPage = page;
    },
    goToNextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    async getAllLevels() {
      await StateStore.actions.actionsGetAllLevelList({ 'axios': this.axios });
      this.items = StateStore.getters.getLevelList();
    }
  },
  created() {
    this.getAllLevels();
  },
};
</script>